import React from 'react';
import { ShieldCheckIcon } from 'lucide-react';
import { Reveal } from './Reveal';
export function GuaranteeSection() {
  return <section className="bg-brand-cream px-4 py-20" data-id="element-76" data-mp="4vs1604r2hrx">
      <Reveal className="mx-auto max-w-2xl text-center" data-id="element-77" data-mp="9umg2qzljm6r">
        <div className="mx-auto mb-7 inline-flex h-16 w-16 items-center justify-center rounded-full border border-brand-line bg-brand-alt" data-id="element-78" data-mp="9t1lj1da838w">
          <ShieldCheckIcon className="h-7 w-7 text-brand-terra" strokeWidth={1.6} aria-hidden="true" data-id="element-79" data-mp="jssgf45r8k9i" />
        </div>
        <h2 className="text-xl font-semibold uppercase tracking-[0.06em] text-brand-navy sm:text-2xl" data-id="element-80" data-mp="nsazrvhxgna8">
          Devolvemos tu dinero o te lo reintegramos
        </h2>
        <p className="mx-auto mt-5 max-w-xl text-sm leading-relaxed text-brand-gray sm:text-base" data-id="element-81" data-mp="xivyrk1ijtto">
          7 días de garantía sin preguntas. Si no es lo que esperabas, te
          devolvemos el dinero. Escribinos al mail y listo.
        </p>
      </Reveal>
    </section>;
}